import template from './survey-filter.html';
import SurveyFilterController from './survey-filter.controller';
import './survey-filter.styl';

let surveyFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: SurveyFilterController,
  controllerAs: 'vm'
};

export default surveyFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/survey-filter/survey-filter.component.js
 **/